import { render } from "./QuestionUIDialog.vue?vue&type=template&id=316abe32"
import script from "./QuestionUIDialog.vue?vue&type=script&lang=js"
export * from "./QuestionUIDialog.vue?vue&type=script&lang=js"

import "./QuestionUIDialog.vue?vue&type=style&index=0&id=316abe32&lang=scss"
script.render = render

export default script